<template>
  <v-navigation-drawer
    app
    :right="$vuetify.rtl"
    :mini-variant.sync="mini"
    floating
    color="gray12"
    class="panel-navigation-drawer"
    :value="drawer"
    @input="test"
  >
    <template v-slot:prepend>
      <v-list-item two-line :class="mini && 'px-2'" dense>
        <v-list-item-content>
          <v-list-item-title class="font-medium-16 primary5--text">{{
            userInfo.firstName + " " + userInfo.lastName
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <v-list dense>
      <template v-for="item in $t('panel.navigationDrawer.menus')">
        <!--        <v-list-group-->
        <!--          v-if="item.subMenus && storeData.includes(item.access)"-->
        <!--          :prepend-icon="item.icon"-->
        <!--          color="white"-->
        <!--          active-class="list-item-bg-color"-->
        <!--          :key="item.name"-->
        <!--        >-->
        <v-list-group
          v-if="item.subMenus"
          :prepend-icon="item.icon"
          color="white"
          active-class="list-item-bg-color"
          :key="item.name"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="white--text" v-text="$t(item.name)" />
            </v-list-item-content>
          </template>
          <template v-for="subItem in item.subMenus">
            <!--            <v-list-item-->
            <!--              link-->
            <!--              :to="subItem.link"-->
            <!--              :key="subItem.name"-->
            <!--              class="pl-8"-->
            <!--              v-if="storeData.includes(subItem.access)"-->
            <!--            >-->
            <v-list-item
              link
              :to="subItem.link"
              :key="subItem.name"
              class="pl-8"
            >
              <v-list-item-action>
                <v-icon>{{ $t(subItem.icon) }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title
                  class="white--text"
                  v-text="$t(subItem.name)"
                />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>
        <!--        <v-list-item-->
        <!--          v-else-if="storeData.includes(item.access)"-->
        <!--          link-->
        <!--          :to="item.link"-->
        <!--          color="white"-->
        <!--          active-class="list-item-bg-color"-->
        <!--          :key="item.name"-->
        <!--        >-->
        <v-list-item
          v-else
          link
          :to="item.link"
          color="white"
          active-class="list-item-bg-color"
          :key="item.name"
        >
          <v-list-item-action>
            <v-icon>{{ $t(item.icon) }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text" v-text="$t(item.name)" />
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
    <template v-slot:append>
      <v-list-item
        link
        color="info"
        @click.stop="mini = !mini"
        dense
        class="d-flex"
      >
        <v-list-item-action>
          <template v-if="!mini">
            <v-icon>mdi-arrow-collapse-left</v-icon>
          </template>
          <template v-else>
            <v-icon>mdi-arrow-collapse-right</v-icon>
          </template>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="white--text">Minimize</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link @click="logout" dense class="logout">
        <template v-if="!logoutLoading">
          <v-list-item-action>
            <v-icon color="error">mdi-power</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{
              $t("panel.navigationDrawer.logout")
            }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <template v-else>
          <v-list-item-content>
            <v-progress-circular
              indeterminate
              color="error"
            ></v-progress-circular>
          </v-list-item-content>
        </template>
      </v-list-item>
    </template>
  </v-navigation-drawer>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { authService } from "@/services";

export default {
  name: "navigation-drawer",
  components: {},
  props: [],

  data: () => ({
    logoutLoading: false,
    mini: false
    // storeData: ["300", "200", "220", "100", "100-1", "100-2"],
  }),
  computed: {
    ...mapGetters({
      drawer: "navigationDrawer/GET_DRAWER",
      userInfo: "userInfo/GET_USERINFO"
    })
  },
  mounted() {},
  methods: {
    test(val) {
      if (!val) {
        this.drawerAction(false);
      }
    },
    ...mapActions({
      drawerAction: "navigationDrawer/ACTION_DRAWER"
    }),
    logout() {
      const refreshToken = {
        refreshToken: localStorage.getItem("refresh_token")
      };
      authService.signOut(refreshToken).then(() => {
        this.logoutLoading = true;
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        this.$router.replace({ name: "loginForm" });
      });
    }
  }
};
</script>
<style lang="scss">
@import "NavigationDrawer";
</style>
